<template>
  <div class="grid-cols-12 gap-4 flex-wrap whitespace-no-wrap" :class="flex ? 'flex' : 'grid'">
    <div v-for="item in items" :key="item"
      class="flex gap-2"
      :class="'col-span-' + Math.ceil(12 / setRowCount)"
    >
      <vs-radio
                :vs-value="item"
                :vs-name="id"
                :readonly="readonly"
                v-model="selectItem">{{item}}</vs-radio>
      <slot v-if="selectItem === item" :name="item"/>
    </div>

  </div>
</template>
<script>
export default {
  name: "RadioGroup",
  props: {
    value: String,
    items: Array,
    /** 한 줄에 표시할 셀의 개수 (1 ~ 4) */
    rowCount: { type: Number, default: 2 },
    flex: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    selectItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    setRowCount() {
      if (4 < this.rowCount) return 4;
      else if (this.rowCount < 1) return 1;
      else return this.rowCount;
    },
  },
  data () {
    return {
      id: Math.random().toString(36).substr(2, 9),
    }
  }
}
</script>

<style scoped lang="scss">

</style>
